import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  footerWrapper: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(6),
  },
}));
